import { css } from 'lit';

var css_248z = css`svg{height:100%;width:100%}.axis text{fill:var(--axis-color)}:host{--axis-color:var(--textNeutralStrong);--line-zero-color:#595b67;--background-color:var(--surfaceCanvasSecondaryInitial);--marker-color:var(--textNeutralStrong);--bar-color-1:#b78423;--bar-color-2:#7c5545;--bar-color-3:#595b67;display:block;width:100%}`;

export { css_248z as default };
//# sourceMappingURL=barChart.styles.css.js.map
